var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ColumnEditModal",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          configName: _vm.configName,
          columnId: _vm.columnId,
          editMode: _vm.editMode,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "edit-modal-additions",
            fn: function (props) {
              return [
                _c(
                  "v-layout",
                  { attrs: { "pa-4": "", wrap: "" } },
                  [
                    _c("h3", [
                      _vm._v(
                        " If the Datum Type does not exist for the sample while a new Datum is being created, the Datum should be auto assigned to a Datum Type of: "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getAutoAssignDepthTypeValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.callSetColumnMetadata(
                              _vm.autoAssignDepthTypeKey,
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: { label: "Depth", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: { label: "Height", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "The Datum should not be created and the import should fail.",
                            value: "2",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      },
      "ColumnEditModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }